
export const CategoryAction = {
    SINGLE_CATEGORY: 'SINGLE_CATEGORY',
    GET_CATEGORY_LIST: 'GET_CATEGORY_LIST'
}

export const WatchLaterAction = {
    ADD_TO_WATCHLATER: 'ADD_TO_WATCHLATER',
}

export const playlistmanagment = {
    CREATE_GLOBAL_PLAYLISTS: 'CREATE_GLOBAL_PLAYLISTS',
    REMOVE_PLAYLIST_FROM_GLOBAL: "REMOVE_PLAYLIST_FROM_GLOBAL",
    SET_CURRENT_VIDEO: 'SET_CURRENT_VIDEO',
    UNSET_CURRENT_VIDEO: 'UNSET_CURRENT_VIDEO'
}

export const likeAction = {
    ADD_TO_LIKES: 'ADD_TO_LIKES',
}

export const historyAction = {
    ADD_TO_HISTORY: 'ADD_TO_HISTORY',
}